export const redirectToCheckout = () => {
  window.location.href = '/checkout'
}
